export default "__VITE_ASSET__C1MhwC7j__"